const moduleName = "order/autoStowageRule";

export const id = {
    id: "AUTO_STOWAGE_RULE",
    method: "GET",
    name: "自动配载规则",
    type: "menu",
    apiName: "getAutoStowageRuleList",
    url: `${moduleName}/list`,
    sort: 108
};

export const children = {
    ADD_DATA: {
        id: "AUTO_STOWAGE_RULE_ADD_DATA",
        name: "新增",
        type: "view"
    },
    EDIT_DATA: {
        id: "AUTO_STOWAGE_RULE_EDIT_DATA",
        name: "编辑",
        type: "view"
    },
    STATUS: {
        id: "AUTO_STOWAGE_RULE_STATUS",
        apiName: "updateAutoStowageRuleStatus",
        method: "POST",
        name: "启用/停用",
        type: "view",
        url: `${moduleName}/status`,
        paramsType: 2,
        paramsKeys: ["id", "status"]
    },
    SAVE: {
        id: "AUTO_STOWAGE_RULE_SAVE",
        apiName: "saveAutoStowageRule",
        method: "POST",
        name: "保存",
        type: "view",
        url: `${moduleName}/save`
    }
};
